import { render } from "./TestimonialFive.vue?vue&type=template&id=0bcba075"
import script from "./TestimonialFive.vue?vue&type=script&lang=js"
export * from "./TestimonialFive.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__